import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

export const ContentWrapper = styled.div`
  margin: 0 auto;
  max-width: 580px;
  transition: opacity 500ms ease-in-out;
  width: 100%;
  color: rgb(119, 120, 123);
  display: flex;
  flex-direction: column;

  .desktop-click {
    display: inline-block;
    font-family: 'source-sans-pro', sans-serif !important;
    padding: 0 3px;
  }
  .mobile-tap {
    display: none;
    font-family: 'source-sans-pro', sans-serif !important;
    padding: 0 3px;
  }

  .side-description {
    line-height: 22px;
  }

  .disclaimer {
    color: ${Colors.accent.grey1.standard};
    display: none;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    padding-top: 8px;

    @media (max-width: 970px) {
      display: block;
    }
  }

  .image-container {
    display: block;
    margin-bottom: 15px;
    position: relative;
    height: 191.25px;

    @media (max-width: 970px) {
      margin: 6px 20px 0 0;
      min-width: 115px;
      height: 71.88px;
    }

    @media (max-width: 320px) {
      min-width: 80px;
      height: 50px;
    }
  }

  @media (max-width: 970px) {
    flex-direction: ${(props) => props.mobileFlex || 'row'};

    .blurb {
      color: ${Colors.accent.grey1.standard};
      line-height: 18px;
      font-size: 14px;
    }

    .side-description {
      text-align: center;
      line-height: 18px;
    }

    .desktop-click {
      display: none;
    }
    .mobile-tap {
      display: inline-block;
    }
  }

  @media (max-width: 970px) {
    min-height: 125px;
  }
`;

export const OptionsLink = styled.a`
  color: #1277c6;
  cursor: pointer;
  display: block;
  font-size: 15px;
  font-weight: bold;
  padding-bottom: 10px;
  text-decoration: none;

  :hover {
    text-decoration: underline;
  }

  @media (max-width: 970px) {
    font-size: 13px;
  }
`;
